
import { apiClient } from "../config";
async function getAddtionalInformation(personId: any) {
  const params = {
    personId: personId,
  };
  const res = await apiClient.get("/admin/profile/additional-information", {
    params,
  });
  return res.data;
}

export default getAddtionalInformation;
